import { render, staticRenderFns } from "./NsFilter.vue?vue&type=template&id=1452ccea&scoped=true&"
import script from "./NsFilter.vue?vue&type=script&lang=js&"
export * from "./NsFilter.vue?vue&type=script&lang=js&"
import style0 from "./NsFilter.vue?vue&type=style&index=0&id=1452ccea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452ccea",
  null
  
)

export default component.exports